import { For, HStack, Text, VStack } from '@chakra-ui/react';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectCoordinatesUnit } from '@redux/settings/settings.selectors';
import { formatCoordinates } from '@utils/validation/coordinates.utils';
import DmsCoordinates from 'dms-conversion';
import { FormattedMessage, useIntl } from 'react-intl';

import { Coordinates } from '@/types/commons/commons.types';

export type InformationModuleProps = {
  informationValues: Map<string, string | number | Coordinates | null | undefined>;
};

function CoordinatesInfo({ coordinates }: Readonly<{ coordinates: Coordinates }>) {
  const userSettingsUnit = useAppSelector(selectCoordinatesUnit);
  const coordinatesDMS = new DmsCoordinates(coordinates.latitude, coordinates.longitude);
  const formattedCoordinates = formatCoordinates(coordinatesDMS, userSettingsUnit);

  return (
    <VStack gap="3px" marginLeft="auto" alignItems="end">
      <Text marginLeft="auto" fontWeight="medium">
        {formattedCoordinates.latitude}
      </Text>
      <Text marginLeft="auto" fontWeight="medium">
        {formattedCoordinates.longitude}
      </Text>
    </VStack>
  );
}

export default function InformationModule({ informationValues }: Readonly<InformationModuleProps>) {
  const { formatMessage } = useIntl();
  return (
    <VStack paddingX={9} paddingY={4} backgroundColor="neutral.700" gap={1} flex="1" height="100%" alignItems="start">
      <Text paddingY="11px" fontWeight="medium" color="neutral.200" textTransform="uppercase">
        <FormattedMessage id={`components.monitoring.sensorDetail.global.information.title`} />
      </Text>
      <For
        each={Array.from(informationValues.entries())}
        fallback={
          <Text color="neutral.300">
            <FormattedMessage id="components.monitoring.sensorDetail.global.empty" />
          </Text>
        }
      >
        {([name, value]) => (
          <HStack paddingY="7px" width="100%" gap={6} key={name} alignItems="start">
            <Text color="neutral.300" flexShrink={0}>
              <FormattedMessage id={`components.monitoring.sensorDetail.global.information.${name}`} />
            </Text>
            {typeof value === 'object' && value !== null ? (
              <CoordinatesInfo coordinates={value} />
            ) : (
              <Text marginLeft="auto" fontWeight="medium" wordBreak="break-all">
                {value !== undefined && value !== null && value !== '' ? value : formatMessage({ id: 'global.NA' })}
              </Text>
            )}
          </HStack>
        )}
      </For>
    </VStack>
  );
}
